import { StandaloneChargeStatusEnum } from '../../services/standalone-charges';

import {
  ActivationFormState,
  CommissioningFiltersState,
  CreateCommissioningCollaboratorFormState,
  CreateFormState,
  FiltersState
} from './types';

export const standaloneChargesLabel = 'Cobranças';

export const statusOptions = [
  { key: 'PENDING_PAYMENT', value: 'PENDING_PAYMENT', text: 'Pendente' },
  { key: 'PAID', value: 'PAID', text: 'Paga' },
  { key: 'CANCELLED', value: 'CANCELLED', text: 'Cancelada' },
  { key: 'EXPIRED', value: 'EXPIRED', text: 'Expirado' }
];

export const statusLabelMap: Record<string, string> = {
  [StandaloneChargeStatusEnum.pendingPayment]: 'Pendente',
  [StandaloneChargeStatusEnum.paid]: 'Paga',
  [StandaloneChargeStatusEnum.cancelled]: 'Cancelada',
  [StandaloneChargeStatusEnum.expired]: 'Expirado'
};

export const initialFilters: FiltersState = {
  estateId: '',
  estateUnitId: '',
  type: 'payer',
  argument: '',
  status: '',
  startDate: '',
  endDate: ''
};

export const initialCommissioningFilters: CommissioningFiltersState = {
  estateId: '',
  type: 'name',
  argument: '',
  status: ''
};

export const initialCreateCommissioningCollaboratorForm: CreateCommissioningCollaboratorFormState = {
  estateId: '',
  userId: '',
  name: '',
  email: '',
  cpf: '',
  phone: '',
  birthdate: '',
  monthlyIncome: '',
  professionalOccupation: '',
  street: '',
  streetNumber: '',
  neighborhood: '',
  city: '',
  state: '',
  zipCode: '',
  referencePoint: '',
  complementary: '',
  bankCode: '',
  bankBranchNumber: '',
  bankBranchCheckDigit: '',
  bankAccountNumber: '',
  bankAccountCheckDigit: '',
  bankAccountType: 'checking'
};

export const initialCreateForm: CreateFormState = {
  estateId: '',
  commissionCollaboratorIds: [],
  amount: 0,
  payerName: '',
  payerCpf: '',
  payerEmail: '',
  payerPhone: '',
  payerAddressStreet: '',
  payerAddressNumber: '',
  payerAddressNeighborhood: '',
  payerAddressComplement: '',
  payerAddressZipCode: '',
  payerAddressCity: '',
  payerAddressState: '',
  payerAddressCountry: 'BR',
  description: '',
  paymentMethod: 'PIX'
};

export const initialActivationForm: ActivationFormState = {
  recipientType: 'corporation',
  email: '',
  document: '',
  phone: '',
  name: '',
  motherName: '',
  birthdate: '',
  monthlyIncome: '',
  professionalOccupation: '',
  companyName: '',
  tradingName: '',
  annualRevenue: '',
  street: '',
  complementary: '',
  streetNumber: '',
  neighborhood: '',
  city: '',
  state: '',
  zipCode: '',
  referencePoint: '',
  partnerName: '',
  partnerEmail: '',
  partnerDocument: '',
  partnerPhone: '',
  partnerMotherName: '',
  partnerBirthdate: '',
  partnerMonthlyIncome: '',
  partnerProfessionalOccupation: '',
  partnerStreet: '',
  partnerComplementary: '',
  partnerStreetNumber: '',
  partnerNeighborhood: '',
  partnerCity: '',
  partnerState: '',
  partnerZipCode: '',
  partnerReferencePoint: '',
  bankHolderName: '',
  bankHolderType: 'individual',
  bankHolderDocument: '',
  bankCode: '',
  bankBranchNumber: '',
  bankBranchCheckDigit: '',
  bankAccountNumber: '',
  bankAccountCheckDigit: '',
  bankAccountType: 'checking'
};
